import React, { forwardRef } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import styled, { createGlobalStyle } from 'styled-components';
const StyledInput = styled.input`
  width: ${(props) => (props.width ? props.width : '100%')};
  color:${(props)=>props?.color ? 'rgba(99, 99, 99, 1)' : 'black'};
  height: 33px !important;
  &:focus {
    outline: 1px solid green;
  }
`;
const StyledInputDiv = styled.div`

  width: ${(props) => (props.width ? props.width : '100%')};
  color:${(props)=>props?.color ? 'rgba(99, 99, 99, 1)' : 'black'};
  height: 33px !important;
  min-width:125px;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 1px 8px;
  border: 1px solid rgb(204, 204, 204);
  border-radius: 4px;
    margin-top:5px;
`;
const DatePickerStyles = createGlobalStyle`
  .react-datepicker__day--selected,
  .react-datepicker__day--keyboard-selected {
    background-color: #57A177 !important;
    color: white !important;
    
  }

  .react-datepicker__day:hover {
    background-color: #81c784 !important;
    color: black !important;
    
  }

  .react-datepicker__day--today {
    border: 1px solid #4caf50;
    font-weight: bold;
  }
  .react-datepicker__day--outside-month {
    visibility: hidden;
  }
`;

// ✅ forwardRef — DatePicker passes ref + onClick through this
const CustomInputWithButton = forwardRef(({
  width, color, style, value, onClick,
}, ref) => (
  <StyledInputDiv
    ref={ref}
    width={width}
    color={color}
    style={style}
    onClick={onClick}
  >
    <span style={{ flex: 1, userSelect: 'none' }}>
      {value || 'Select a date'}
    </span>
    <button
      onClick={onClick}
      type="button"
      style={{
        background: 'none',
        border: 'none',
        padding: '0px',
        cursor: 'pointer',
        fontSize: '16px',
        lineHeight: 1,
      }}
    >
      📅
    </button>
  </StyledInputDiv>
));

CustomInputWithButton.displayName = 'CustomInputWithButton';

// ✅ Handles both 'YYYY-MM-DD' strings AND Date objects
// Uses local time to avoid UTC timezone shift bug
const toLocalDate = (input) => {
  if (!input) return null;

  // Already a valid Date object — return as-is
  if (input instanceof Date) {
    return isNaN(input.getTime()) ? null : input;
  }

  // String handling
  if (typeof input === 'string') {
    const parts = input.split(/[-\/]/);
    if (parts.length === 3) {
      let year, month, day;
      if (parts[0].length === 4) {
        // 'YYYY-MM-DD'
        [year, month, day] = parts.map(Number);
      } else {
        // 'DD-MM-YYYY' or 'DD/MM/YYYY'
        [day, month, year] = parts.map(Number);
      }
      if (!year || !month || !day) return null;
      const date = new Date(year, month - 1, day); // local time — no UTC shift
      return isNaN(date.getTime()) ? null : date;
    }
  }

  return null;
};

const MyDatePicker = ({
  value,
  dateHandler,
  format = 'dd-MM-yyyy',
  min,
  max,
  name,
  count,          //added — passed as 2nd arg to dateHandler
  width = '100%',
  color=false,
  readOnlyvalue = false,
  style = {},
}) => {

  const isValidDate = (date) =>
    date instanceof Date && !isNaN(date.getTime());

  const validateDate = (date) => {
    const start = toLocalDate(min);
    const end = toLocalDate(max);

    // ✅ date from DatePicker is already a Date object — use directly
    if (!isValidDate(start) || !isValidDate(end) || !isValidDate(date))
      return false;

    // ✅ normalize to midnight to avoid time-of-day comparison issues
    const normalize = (d) =>
      new Date(d.getFullYear(), d.getMonth(), d.getDate());

    return (
      normalize(date) >= normalize(start) &&
      normalize(date) <= normalize(end)
    );
  };

  const changeDate = (date) => {
    // ✅ guard against missing dateHandler
    if (typeof dateHandler !== 'function') {
      console.error('MyDatePicker: dateHandler prop is not a function');
      return;
    }

    if (validateDate(date)) {
      // ✅ date is already a Date object — pass directly
      // ✅ count passed as 2nd arg so dateHandler knows which topic
      dateHandler({ value: date, name }, count);
    } else {
      // clamp to boundary if out of range
      dateHandler({
        value: name === 'firstPostDate' ? toLocalDate(min) : toLocalDate(max),
        name,
      }, count);
    }
  };

  return (
    <div>
      <DatePickerStyles />
      <DatePicker
        selected={toLocalDate(value)}         // ✅ always Date or null
        onChange={(date) => changeDate(date)}
        dateFormat={format}
        minDate={toLocalDate(min)}            // ✅ always Date or null
        maxDate={toLocalDate(max)}            // ✅ always Date or null
        // ✅ readOnly removed — was disabling entire picker
        // ✅ popperTargetRef removed — forwardRef handles positioning
        customInput={
          <CustomInputWithButton            // ✅ no buttonRef needed
            width={width}
            color={color}
            style={style}
          />
        }
      />
    </div>
  );
};

export default MyDatePicker;







